import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { Feature, SelectOption } from '../../../../../../../../../shared/interfaces';

import { PlanType } from '../../../../../shared';

interface StepTwoFormContextProps {
  stepTwoForm:                        FormInstance<any> | undefined;

  activeKey:                          any;
  setActiveKey:                       Dispatch<SetStateAction<any>>;

  homeFormValues:                     any;
  setHomeFormValues:                  Dispatch<SetStateAction<any>>

  tabs:                               Array<any>;
  setTabs:                            Dispatch<SetStateAction<Array<any>>>;

  newTabIndex:                        { current: number };

  isPlanTypeADisabled:                boolean;
  isPlanTypeCDisabled:                boolean;

  setIsPlanTypeADisabled:             Dispatch<SetStateAction<boolean>>;
  setIsPlanTypeCDisabled:             Dispatch<SetStateAction<boolean>>;

  allFeatures:                        Array<{ plan: string; keyTab: number; features: Array<Feature> }>;
  setAllFeatures:                     Dispatch<SetStateAction<Array<{ plan: string; keyTab: number; features: Array<Feature> }>>>;

  showModal:                          boolean;
  setShowModal:                       Dispatch<SetStateAction<boolean>>;

  keyTabToDelete:                     number | null;
  setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;

  planOptionsBySelectedPlan:          Array<SelectOption>;

  areTabActionsAllowed:               boolean;
  planTypeSelected:                   PlanType;
  setPlanTypeSelected:                Dispatch<SetStateAction<PlanType>>;
  resetTabs:                          (unconfirmedPlanType: PlanType) => void;

  addNewTab:                          (id?: number) => void;
  duplicateTab:                       (id?: number) => void;
  removeTab:                          (id?: any) => void;

  getFeaturesRisks:                   (planSelected: string, componente: number) => Promise<Array<Feature>>;

  getOptionsTypesHousing:             (planSelected: string) => Promise<void>;

  housingTypeOptionsPerPlan:          Array<{ plan: string, housingTypes: Array<SelectOption> }>;
}

export const StepTwoFormContext = createContext(
  {} as StepTwoFormContextProps
);